export default __webpack_public_path__ + "static/media/Radar_Black.96ae87e0.webp";